<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";
import UtilNumber from "@/utils/UtilNumber";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
    "subItem",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:removeSubitem",
    "update:descartaSubitem",
    "update:alteraSubitem",
]);

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update = {}) =>{

    update.id = props.subItem.id;
    update.remover = !props?.subItem?.remover;
    emits('update:removeSubitem',update);

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update = {}) =>{

    update.id = props.subItem.id;
    emits('update:descartaSubitem',update);

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update = {}) => {

    update.id = props.subItem.id;
    emits('update:alteraSubitem',update);

};

//==================================================================//
//==================== Mostra Descartar Subitem ====================//
//==================================================================//

let mostraDescartarSubitem = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    return props?.subItem?.rascunho ? true : false;

});

//==================================================================//
//================ Mostra Remover Item Vermelho ====================//
//==================================================================//

let mostraRemoverItemVermelho = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    let subItemEstaSalvo = props?.subItem?.salvo ? true : false;
    let subItemMarcadoParaRemocao = props?.subItem?.remover ? true : false;

    if(subItemEstaSalvo && subItemMarcadoParaRemocao == false){
        return true;
    }

    return false;

});

//==================================================================//
//================ Mostra Remover Item Preto =======================//
//==================================================================//

let mostraRemoverItemPreto = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    let subItemEstaSalvo = props?.subItem?.salvo ? true : false;
    let subItemMarcadoParaRemocao = props?.subItem?.remover ? true : false;

    if(subItemEstaSalvo && subItemMarcadoParaRemocao == true){
        return true;
    }

    return false;

});

//==================================================================//
//======================== Desativa Campos =========================//
//==================================================================//

let desativaCampos = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//====================== Regras Valor Unitario =====================//
//==================================================================//

const regrasValorUnitario = [
    valor => {
        let valorFormatado = valor.replace(/,/g, ".");
        if(valorFormatado === ""){
            return false;
        }else if(0.00 >= parseFloat(valorFormatado)){
            return false;
        }
        return true;
    }
];

//==================================================================//
//==================== Ao Descartar Subitem ========================//
//==================================================================//

const aoDescartarSubItem = () => {

    descartaSubitem({});

};

//==================================================================//
//===================== Ao Remover Subitem =========================//
//==================================================================//

const aoRemoverSubitem = () => {

    removeSubitem({});

};

//==================================================================//
//===================== Ao Preencher Descricao =====================//
//==================================================================//

const aoPreencherDescricao = (descricao) => {

    alteraSubitem({
        descricao: descricao
    });

};

//==================================================================//
//===================== Ao Preencher Quantidade ====================//
//==================================================================//

const aoPreencherQuantidade = (quantidade) => {

    alteraSubitem({
        quantidade: UtilNumber.toNumber(quantidade),
    });

};

//==================================================================//
//=================== Ao Preencher Valor Unitario ==================//
//==================================================================//

const aoPreencherValorUnitario = (valorUnitario = 0) => {

    alteraSubitem({
        valorUnitario: UtilMoney.toNumber(valorUnitario),
    });

};

</script>

<template>

    <div class="c-table__row">

        <div class="c-table__cell">

            <v-tooltip bottom>

                <template v-slot:activator="{ on, attrs }">

                    <v-btn class="c-botao-descartar-subitem mx-2"
                        v-show="mostraDescartarSubitem"
                        :disabled="props?.controlesDesativados"
                        fab
                        dark
                        small
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="aoDescartarSubItem()"
                    >

                        <v-icon dark>
                            mdi-trash-can-outline
                        </v-icon>
                    
                    </v-btn>

                </template>

                <span>Descartar Subitem</span>

            </v-tooltip>

            <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-remover-item-vermelho mx-2"
                            v-show="mostraRemoverItemVermelho"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="red"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoRemoverSubitem"
                        >

                            <v-icon dark>
                                mdi-delete
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Remover Item</span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-remover-item-preto mx-2"
                            v-show="mostraRemoverItemPreto"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="212121"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoRemoverSubitem"
                        >

                            <v-icon dark>
                                mdi-delete-alert
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Remover Item</span>

                </v-tooltip>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cube-outline
                    </v-icon>

                    <span class="c-table__cell-content-text">
                        {{props?.subItem?.sequencia}}
                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-textarea
                    :value="props?.subItem?.descricao"
                    :disabled="desativaCampos"
                    label="Descrição"
                    variant="outlined"
                    no-resize
                    outlined
                    rows="1"
                    hide-details
                    auto-grow
                    @input="aoPreencherDescricao"
                ></v-textarea>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    :value="props?.subItem?.quantidade"
                    :disabled="desativaCampos"
                    label="Quantidade"
                    outlined
                    type="number"
                    prepend-icon="mdi-counter"
                    hide-details
                    @input="aoPreencherQuantidade"
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.subItem?.valorUnitario"
                    label="Preço Unitário"
                    outlined
                    type="number"
                    hide-details
                    :rules="regrasValorUnitario"
                    :disabled="desativaCampos"
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                    @input="aoPreencherValorUnitario"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                R$ {{UtilMoney.toBRL(props?.subItem?.valorTotal)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #f0f0f0;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

/*==================================================================*/
/*==================== Ao Descartar Subitem ========================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-descartar-subitem{
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-remover-item-vermelho{
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-remover-item-preto{
    background-color: #212121 !important;
    border-color: #212121 !important;
}


</style>